import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {PgCalculationRequest, PgCalculationResult, PgCreatePolicyRequest, PgProductAvailableParams} from '../models/sales-pg.model';
import {Clause} from '../models/product.model';
import {Policy} from '../models/policy.model';
import {AvailableQuestionnaire, FilledQuestionnaire} from '../models/questionnaire.model';
import {skipInterceptors} from '../helpers/request.helper';

@Injectable()
export class SalesPgService {

    baseProductUrl = '/api/secured/product/pg';
    baseSalesUrl = '/api/secured/sales/pg';

    constructor(private http: HttpClient) {
    }

    getAvailability() {
        return this.http.get<PgProductAvailableParams>(`${this.baseProductUrl}/availability`, {});
    }

    getQuestionnaire() {
        const headers: HttpHeaders = skipInterceptors([404]);
        return this.http.get<AvailableQuestionnaire>(`${this.baseSalesUrl}/questionnaire`, {headers});
    }

    validateQuestionnaire(payload: FilledQuestionnaire) {
        return this.http.post<PgCalculationResult[]>(`${this.baseSalesUrl}/validate-questionnaire`, {...payload});
    }

    calculate(payload: PgCalculationRequest) {
        return this.http.put<PgCalculationResult[]>(`${this.baseSalesUrl}/calculate`, {...payload});
    }

    getClauses(payload: PgCalculationResult) {
        return this.http.post<Clause[]>(`${this.baseSalesUrl}/clauses`, {...payload});
    }

    createPolicy(payload: PgCreatePolicyRequest) {
        return this.http.put<Policy>(`${this.baseSalesUrl}/create-policy`, {...payload});
    }

    downloadPrintout(payload: string, addKidOwu = false){
        window.location.href = `${this.baseSalesUrl}/${payload}/download-policy?addKidOwu=${addKidOwu}`;
    }

    policyPrintoutApprovalDownload(policyId: string){
        window.location.href = `${this.baseSalesUrl}/${policyId}/policy-approval-printout`;
    }

}
